/* eslint simple-import-sort/imports: 0 */

import { useMotionValue, useSpring, useTransform } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

import useElementSize from 'hooks/useElementSize';

import * as S from './MouseSlider.styles';

export interface MouseSliderProps {
  children: React.ReactNode;
}

const MouseSlider: React.FunctionComponent<MouseSliderProps> = ({
  children,
  ...rest
}) => {
  const { ref, inView } = useInView();
  const { size: wrapperSize, ref: wrapperRef } = useElementSize();
  const { size: contentSize, ref: contentRef } = useElementSize();
  const [enableDrag, setEnableDrag] = useState(true);

  const mousePosition = useMotionValue(0);
  const sliderTransform = useTransform(
    mousePosition,
    [0, wrapperSize.width],
    [0, -contentSize.width + wrapperSize.width * 0.95]
  );
  const springSlider = useSpring(sliderTransform, {
    mass: 0.01,
    damping: 10,
    stiffness: 150,
  });

  const animateSliderOnMouseMove = (event: MouseEvent) => {
    mousePosition.set(event.clientX);
  };

  const isTouchDevice = () => {
    return typeof window.ontouchstart !== 'undefined';
  };

  useEffect(() => {
    setEnableDrag(isTouchDevice());
    inView &&
      !enableDrag &&
      window.addEventListener('mousemove', animateSliderOnMouseMove);
    !inView &&
      window.removeEventListener('mousemove', animateSliderOnMouseMove);
    return () => {
      window.removeEventListener('mousemove', animateSliderOnMouseMove);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <S.SliderWrapper ref={wrapperRef} {...rest}>
      <div ref={ref} />
      <S.SliderContent
        style={{ x: springSlider }}
        ref={contentRef}
        drag={enableDrag ? 'x' : false}
        dragConstraints={{
          left: -contentSize.width + wrapperSize.width,
          right: 0,
        }}
        dragElastic={1}
      >
        {children}
      </S.SliderContent>
    </S.SliderWrapper>
  );
};
export default MouseSlider;
